import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getUsers as getUsersApi,
  deleteUsers as deleteUsersApi,
  getUserProfile as getUserProfileApi,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import {
  changeRoleStatus,
  createRoles,
  getRolesByEntity,
  updateRoles,
} from "../../helpers/dataBackend";
import { fetchRolesFailure, fetchRolesSuccess, listRoles } from "./reducer";
import { AppDispatch } from "slices";

// export const fetchRolesEntity = () => async (dispatch: AppDispatch) => {
//   dispatch(listRoles());
//   try {
//     const response = await getRolesByEntity();
//     dispatch(fetchRolesSuccess(response));
//   } catch (error: any) {
//     dispatch(fetchRolesFailure(error));
//   }
// };

export const fetchRolesEntity = createAsyncThunk(
  "role/fetchRoles",
  async () => {
    try {
      const response = await getRolesByEntity();
      // console.log(JSON.parse(response.data));
      return JSON.parse(response.data);
    } catch (error) {
      return error;
    }
  }
);

export const addNewRole = createAsyncThunk(
  "role/addRole",
  async (roles: any) => {
    try {
      const response = await createRoles(roles);
      toast.success("Role Added Successfully", { autoClose: 2000 });
      // console.log(response);
      return response;
    } catch (error) {
      toast.error("Role Added Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const updateRole = createAsyncThunk(
  "roles/updatroles",
  async (roles: any) => {
    try {
      const role = {
        name: roles.name,
        description: roles.description,
        permissions: roles.permissions,
      };
      const response = updateRoles(roles.id, role);
      const data = await response;
      toast.success("Role Updated Successfully", { autoClose: 2000 });
      return data;
    } catch (error) {
      toast.error("Role Updated Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const deleteRoles = createAsyncThunk(
  "roles/deleteRoles",
  async (id: any) => {
    try {
      const response = changeRoleStatus(id);
      toast.success("Role Deleted Successfully", { autoClose: 2000 });
      const data = await response;
      return JSON.parse(data.data);
    } catch (error) {
      toast.error("Role Deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

// TODO - DEPRECATED
export const deleteUsers = createAsyncThunk(
  "contacts/deleteUsers",
  async (users: any) => {
    try {
      const response = deleteUsersApi(users);
      toast.success("Role Deleted Successfully", { autoClose: 2000 });
      return response;
    } catch (error) {
      toast.error("Role Deleted Failed", { autoClose: 2000 });
      return error;
    }
  }
);

export const getUserProfile = createAsyncThunk(
  "contacts/getUserProfile",
  async () => {
    try {
      const response = getUserProfileApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getUsers = createAsyncThunk("contacts/getUsers", async () => {
  try {
    const response = getUsersApi();
    return response;
  } catch (error) {
    return error;
  }
});
